import { useTranslation } from '../../i18n/LanguageContext'
import './LoadingOverlay.css'

const LoadingOverlay = ({ children, className = '', label }) => {
  const { t } = useTranslation()
  const ariaLabel = label || t('loading.loading')
  return (
    <div
      className={`loading-overlay ${className}`}
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
    >
      <div className="loading-overlay__content">
        {children}
      </div>
    </div>
  )
}

export default LoadingOverlay
